function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 53C13.885 41.098 21.334 22.334 31 7c3.806-.542-9.304 33.517-22 44-1.871 1.545-7 2-7 2zM39 2c-3.66.296-7.85-.141-8 5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 7s9.966-1.165 13 2c2.09 2.179 2.87 6.63 1 9-1.664 2.11-6.116 2.917-8 1-1.652-1.681-2-5 1-7 3.648-2.432 9.983-1.181 13 2 2.305 2.43 2.738 7.136 1 10-1.862 3.07-7.027 6.013-10 4-1.932-1.308-1.186-5.19.97-6.084 7.03-2.916 8 9 8 9"
}));

var SvgStringbean = function SvgStringbean(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStringbean, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/String bean.fe185981.svg";
export { ForwardRef as ReactComponent };